import * as correspondentOnboardingAction from './action';
const initialState = {
    correspondentCreateSuccess: [],
    correspondentCreateFailure: [],
    correspondentEditSuccess: [],
    correspondentEditFailure: [],
    correspondentDetails: [],
    correspondentDetailsFailure: []
}
const correspondentOnboardingCreateReducer = (state = initialState, action) => {
    switch (action.type) {
        case correspondentOnboardingAction.FETCH_CORRESPONDENT_ENTITY_DETAILS_SUCCESS:
            return state = {
                ...state,
                correspondentDetails: action.data
            }
        case correspondentOnboardingAction.FETCH_CORRESPONDENT_ENTITY_DETAILS_FAILURE:
            return state = {
                ...state,
                correspondentDetailsFailure: action.data
            }
        case correspondentOnboardingAction.CREATE_CORRESPONDENT_ENTITY_SUCCESS:
            return state = {
                ...state,
                correspondentCreateSuccess: action.data
            }
        case correspondentOnboardingAction.CREATE_CORRESPONDENT_ENTITY_FAILURE:
            return state = {
                ...state,
                correspondentCreateFailure: action.data
            }
        case correspondentOnboardingAction.EDIT_CORRESPONDENT_ENTITY_SUCCESS:
            return state = {
                ...state,
                correspondentEditSuccess: action.data
            }
        case correspondentOnboardingAction.EDIT_CORRESPONDENT_ENTITY_FAILURE:
            return state = {
                ...state,
                correspondentEditFailure: action.data
            }
        default: return state
    }
};

export default correspondentOnboardingCreateReducer; 